import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateChapter } from "src/modules/book/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createChapter } = props;
    const router = useRouter();
    const { book_id } = router.query;

    const onFinish = async (values: any) => {
        await createChapter(values);
        router.push(`/book/chapter/${book_id}`);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateChapter)(Create);
